<template>
    <!-- <div class="item-grid-view vx-row match-height">
        <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
    <vx-card class="grid-view-item mb-base overflow-hidden" v-on="$listeners">
        <template slot="no-body">

            <!-- ITEM IMAGE -->
            <div class="item-img-container bg-primary h-64 flex items-center justify-center mb-4 cursor-pointer" style="z-index: -6;overflow:hidden;" @click="navigate_to_detail_view">
                <img style="z-index: 0;" v-if="item.image_name.length > 0" :src="'/api/listing/v1/foodImage/' + item.image_name" :alt="item.name" class="grid-view-img">
            </div>
            <div class="item-details px-4" style="z-index: 10;">

                <!-- RATING & PRICE -->
                <div class="flex justify-between items-center">
                    <h6 class="truncate font-semibold mb-1 hover:text-primary cursor-pointer" @click="navigate_to_detail_view">{{ item.name }}</h6>
                    <h6 class="font-bold">{{ item.price }}&euro;</h6>
                </div>

                <!-- TITLE & DESCRIPTION -->
                <div class="my-4">
                    <p class="item-description truncate text-sm">{{ item.description }}</p>
                </div>
            </div>

            <!-- SLOT: ACTION BUTTONS -->
            <slot name="action-buttons" />
        </template>
    </vx-card>
    <!--  </div>
 </div> -->
</template>

<script>
    export default{
        props: {
            item: {
                type: Object,
                required: true
            },
        },
        methods: {
            navigate_to_detail_view() {
                this.$router.push("/food/" + this.item.id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .grid-view-item {
        .grid-view-img {
            max-width: 100%;
            min-width: 100%;
            transition: .35s;
        }

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

            .grid-view-img{
                opacity: 0.9;
            }
        }
    }
</style>
